"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPrivateRace = exports.hasUnlockRace = exports.hasUnlockCareer = exports.GROUP_NAME = exports.getRaceSpecialSkills = exports.getRaceGroup = exports.getRaceFromPlayer = exports.getRaceFromCareer = exports.getRaceCompatibility = exports.getPlayersByState = exports.getPlayerGroup = exports.getPlayerCompatibility = exports.getPlayerAvatarPath = exports.getPlayerAvatarDefault = exports.getPlayerAvatar = exports.getCareersByRace = exports.getCareerKeyFromPlayer = exports.getCareerFromPlayer = exports.getCareerFromKey = exports.getCareerFromIcon = exports.getCareerId2025 = exports.getAvatarTypeFromPlayer = exports.getAvatarRarityFromFile = exports.getAvatarBasePathFromFile = exports.getAvailableCareersByRace = exports.GAIN_CAREER_POINT_FRIENDLY = exports.GAIN_CAREER_POINT = exports.COMPATIBILITY = exports.ANIMOSITY_NUMBER = void 0;
exports.getCareerRanges = getCareerRanges;
exports.getPlayersAvailableForPromo = getPlayersAvailableForPromo;
exports.getPriceCareer = getPriceCareer;
exports.getPromoCareer = getPromoCareer;
exports.getTeamGroups = getTeamGroups;
exports.getTeamIncompatibleGroups = getTeamIncompatibleGroups;
exports.isNeutralGroup = isNeutralGroup;
exports.isPlayerNeutralGroup = isPlayerNeutralGroup;
const seedrandom_1 = __importDefault(require("seedrandom"));
const avatars_1 = require("./avatars");
const avatarsDefault_1 = require("./avatarsDefault");
const avatarsSeason_1 = require("./avatarsSeason");
const badge_1 = require("./badge");
const career_1 = require("./career");
const random_1 = require("./random");
const skill_1 = require("./skill");
const state_1 = require("./state");
const ANIMOSITY_NUMBER = 2;
exports.ANIMOSITY_NUMBER = ANIMOSITY_NUMBER;
const isPrivateRace = (race) => {
    return [
        career_1.RACE.UNDEAD,
        career_1.RACE.VAMPIRE,
        career_1.RACE.ELVEN_UNION,
        career_1.RACE.GOBELIN,
        career_1.RACE.IMPERIAL,
        career_1.RACE.KHORNE,
        career_1.RACE.NECROMANTIC,
        career_1.RACE.NURGLE,
        career_1.RACE.SNOTLING,
        career_1.RACE.SLANN,
    ].includes(race);
};
exports.isPrivateRace = isPrivateRace;
const hasUnlockRace = (user, race) => {
    if (!user.badges) {
        throw Error("no badges for player");
    }
    if (!isPrivateRace(race)) {
        return true;
    }
    if (race === career_1.RACE.UNDEAD) {
        if ((0, badge_1.hasBadge)(badge_1.BADGE_NAMES.DEAD, user)) {
            return true;
        }
    }
    if (race === career_1.RACE.KHORNE) {
        if ((0, badge_1.hasBadge)(badge_1.BADGE_NAMES.BLOODTHIRSTY, user)) {
            return true;
        }
    }
    if (race === career_1.RACE.VAMPIRE) {
        if ((0, badge_1.hasBadge)(badge_1.BADGE_NAMES.VAMPIRE, user)) {
            return true;
        }
    }
    if (race === career_1.RACE.ELVEN_UNION) {
        if ((0, badge_1.hasBadge)(badge_1.BADGE_NAMES.ELVEN_UNION, user)) {
            return true;
        }
    }
    if (race === career_1.RACE.SNOTLING) {
        if ((0, badge_1.hasBadge)(badge_1.BADGE_NAMES.SNOTLING, user)) {
            return true;
        }
    }
    if (race === career_1.RACE.IMPERIAL) {
        if ((0, badge_1.hasBadge)(badge_1.BADGE_NAMES.IMPERIAL, user)) {
            return true;
        }
    }
    if (race === career_1.RACE.NECROMANTIC) {
        if ((0, badge_1.hasBadge)(badge_1.BADGE_NAMES.DEAD_FULL_MOON, user)) {
            return true;
        }
    }
    if (race === career_1.RACE.GOBELIN) {
        if ((0, badge_1.hasBadge)(badge_1.BADGE_NAMES.WEAPON, user)) {
            return true;
        }
    }
    if (race === career_1.RACE.NURGLE) {
        if ((0, badge_1.hasBadge)(badge_1.BADGE_NAMES.NURGLE, user)) {
            return true;
        }
    }
    if (race === career_1.RACE.SLANN) {
        if ((0, badge_1.hasBadge)(badge_1.BADGE_NAMES.SLANN, user)) {
            return true;
        }
    }
    return false;
};
exports.hasUnlockRace = hasUnlockRace;
const hasUnlockCareer = (user, careerId) => {
    if (!user.badges) {
        throw Error("no badges for player");
    }
    const race = getRaceFromCareer(careerId);
    return hasUnlockRace(user, race);
};
exports.hasUnlockCareer = hasUnlockCareer;
const getCareerFromKey = (key) => {
    const careers = (0, career_1.getCareers)();
    return careers[key];
};
exports.getCareerFromKey = getCareerFromKey;
const getCareerKeyFromPlayer = (player) => {
    // Attention la career est le race_id dans la table player
    return player.race_id;
};
exports.getCareerKeyFromPlayer = getCareerKeyFromPlayer;
/**
 * Maps legacy (pre-2025) career IDs to their 2025 equivalents.
 * Derived by inverting the ICON_ADAPTER from convert-csv-to-career.ts:
 *   old icon name (strip "1") → new 2025 career ID
 */
const LEGACY_TO_2025_CAREER_ID = {
    // Amazon
    "amazon-linewomen": "amazon-linewoman-2025",
    "amazon-blocker": "amazon-blocker-2025",
    "amazon-blitzer": "amazon-blitzer-2025",
    "amazon-catcher": "amazon-catcher-2025",
    "amazon-thrower": "amazon-thrower-2025",
    // Chaos Chosen
    "chaos-beastman": "chaos-chosen-beastman-2025",
    "chaos-warrior": "chaos-chosen-chosen-2025",
    "chaos-minotaur": "chaos-chosen-minotaur-2025",
    // Chaos Dwarf
    "chaos-dwarf-blocker": "chaos-dwarf-blocker-2025",
    "chaos-dwarf-bull-centaur": "chaos-dwarf-bull-centaur-2025",
    "chaos-dwarf-hobgobelin": "chaos-dwarf-hobgoblin-2025",
    // Dark Elf
    "dark-elfe-blitzer": "dark-elf-blitzer-2025",
    "dark-elfe-lineman": "dark-elf-lineman-2025",
    "dark-elfe-runner": "dark-elf-runner-2025",
    "dark-elfe-witch": "dark-elf-witch-elf-2025",
    // Dwarf
    "dwarf": "dwarf-lineman-2025",
    "dwarf-blocker": "dwarf-lineman-2025",
    "dwarf-blitzer": "dwarf-blitzer-2025",
    "dwarf-deathroller": "dwarf-deathroller-2025",
    "dwarf-runner": "dwarf-runner-2025",
    "dwarf-troll-slayer": "dwarf-troll-slayer-2025",
    // Elven Union
    "elven-union-blitzer": "elven-union-blitzer-2025",
    "elven-union-catcher": "elven-union-catcher-2025",
    "elven-union-lineman": "elven-union-lineman-2025",
    "elven-union-thrower": "elven-union-thrower-2025",
    // Goblin
    "gobelin-lineman": "goblin-lineman-2025",
    "gobelin-looney": "goblin-loony-2025",
    "gobelin-pogoer": "goblin-pogoer-2025",
    "gobelin-troll": "goblin-troll-2025",
    // Halfling
    "halfling-lineman": "halfling-lineman-2025",
    "halfling-hefty": "halfling-hefty-2025",
    "halfling-catcher": "halfling-catcher-2025",
    "halfling-treeman": "halfling-treeman-2025",
    // Human
    "human": "human-lineman-2025",
    "human-lineman": "human-lineman-2025",
    "human-blitzer": "human-blitzer-2025",
    "human-catcher": "human-catcher-2025",
    "human-ogre": "human-ogre-2025",
    "human-thrower": "human-thrower-2025",
    // Imperial Nobility
    "imperial-lineman": "imperial-nobility-retainer-2025",
    "imperial-blitzer": "imperial-nobility-blitzer-2025",
    "imperial-bodyguard": "imperial-nobility-bodyguard-2025",
    "imperial-ogre": "imperial-nobility-ogre-2025",
    "imperial-thrower": "imperial-nobility-thrower-2025",
    // Khorne
    "khorne-lineman": "khorne-marauder-2025",
    "khorne-khorngor": "khorne-khorngor-2025",
    "khorne-bloodseeker": "khorne-bloodseeker-2025",
    "khorne-bloodspawn": "khorne-bloodspawn-2025",
    // Lizardmen
    "lizardmen-chameleon": "lizardmen-chameleon-2025",
    "lizardmen-kroxigor": "lizardmen-kroxigor-2025",
    "lizardmen-saurus": "lizardmen-saurus-2025",
    "lizardmen-skink": "lizardmen-skink-2025",
    // Necromantic
    "necromantic-zombie": "necromantic-horror-zombie-2025",
    "necromantic-ghoul": "necromantic-horror-ghoul-2025",
    "necromantic-wraith": "necromantic-horror-wraith-2025",
    "necromantic-werewolf": "necromantic-horror-werewolf-2025",
    "necromantic-golem": "necromantic-horror-flesh-golem-2025",
    // Norse
    "norse-lineman": "norse-raider-2025",
    "norse-berserker": "norse-berserker-2025",
    "norse-catcher": "norse-catcher-2025",
    "norse-thrower": "norse-thrower-2025",
    "norse-ulfwereners": "norse-ulfwerner-2025",
    "norse-yhetee": "norse-yhetee-2025",
    // Nurgle
    "nurgle-rotter": "nurgle-rotter-2025",
    "nurgle-pestigor": "nurgle-pestigor-2025",
    "nurgle-bloater": "nurgle-bloater-2025",
    "nurgle-rotspawn": "nurgle-rotspawn-2025",
    // Orc
    "orc": "orc-lineman-2025",
    "orc-lineman": "orc-lineman-2025",
    "orc-black-orc": "orc-big-un-2025",
    "orc-blitzer": "orc-blitzer-2025",
    "orc-thrower": "orc-thrower-2025",
    "orc-troll": "orc-troll-2025",
    // Skaven (anciens "rat")
    "rat": "skaven-clanrat-2025",
    "rat-lineman": "skaven-clanrat-2025",
    "rat-runner": "skaven-gutter-2025",
    "rat-blitzer": "skaven-blitzer-2025",
    "rat-thrower": "skaven-thrower-2025",
    "rat-ogre": "skaven-rat-ogre-2025",
    // Shambling Undead (anciens "undead")
    "undead-skeleton": "shambling-undead-skeleton-2025",
    "undead-zombie": "shambling-undead-zombie-2025",
    "undead-ghoul": "shambling-undead-ghoul-2025",
    "undead-wight": "shambling-undead-wight-2025",
    "undead-mummies": "shambling-undead-mummy-2025",
    // Snotling
    "snotling-lineman": "snotling-lineman-2025",
    "snotling-runner": "snotling-runna-2025",
    "snotling-wagon": "snotling-pump-wagon-2025",
    "snotling-troll": "snotling-troll-2025",
    // Vampire
    "vampire-thrall": "vampire-thrall-2025",
    "vampire-vampire": "vampire-blitzer-2025",
    // Wood Elf (anciens "silvan")
    "silvan": "wood-elf-lineman-2025",
    "silvan-lineman": "wood-elf-lineman-2025",
    "silvan-thrower": "wood-elf-thrower-2025",
    "silvan-catcher": "wood-elf-catcher-2025",
    "silvan-wardancer": "wood-elf-wardancer-2025",
};
/**
 * Returns the 2025 career ID for a given career ID (legacy or already 2025).
 * Returns undefined for careers without a 2025 equivalent (e.g. Slann).
 */
const getCareerId2025 = (careerId) => {
    if (careerId.endsWith("-2025"))
        return careerId;
    return LEGACY_TO_2025_CAREER_ID[careerId];
};
exports.getCareerId2025 = getCareerId2025;
const getCareerFromPlayer = (player) => {
    const careerKey = getCareerKeyFromPlayer(player);
    return getCareerFromKey(careerKey);
};
exports.getCareerFromPlayer = getCareerFromPlayer;
const getCareerFromIcon = (nameIcon) => {
    for (const [key, values] of Object.entries((0, career_1.getCareers)())) {
        if (values.icons.includes(nameIcon)) {
            return getCareerFromKey(key);
        }
    }
    return null;
};
exports.getCareerFromIcon = getCareerFromIcon;
const getPlayerAvatarDefault = (player) => {
    const avatars = avatarsDefault_1.AVATAR_DEFAULT_LIST;
    const career = getCareerFromPlayer(player);
    const listAvailable = [];
    for (const avatar of career.avatars) {
        // Temporary. Before theiy can choose their default avatar
        if ((career.badge === career_1.RACE.HUMAN ||
            career.badge === career_1.RACE.IMPERIAL ||
            career.badge === career_1.RACE.NORSE) &&
            avatar === career_1.AVATAR.HUMAN_WOMAN) {
            continue;
        }
        if (avatars[avatar]) {
            avatars[avatar].forEach((item) => {
                listAvailable.push(item);
            });
        }
    }
    if (listAvailable.length === 0) {
        return null;
    }
    const random = (0, seedrandom_1.default)(player.id);
    return listAvailable[(0, random_1.getRandomNumber)(0, listAvailable.length - 1, random)]
        .file;
};
exports.getPlayerAvatarDefault = getPlayerAvatarDefault;
const getPlayerAvatar = (player) => {
    const av = player.avatar || player.avatarDefault;
    if (!av) {
        return null;
    }
    // Les avatars saisonniers (format "s17/1.png" ou trouvés dans la liste) gardent leur extension
    // Normalise .jpeg → .png car les fichiers sont PNG (anciens enregistrements DB peuvent avoir .jpeg)
    if (av.includes("/") || (0, avatarsSeason_1.findSeasonAvatar)(av)) {
        return av.replace(".jpeg", ".png");
    }
    return av.replace(".png", ".jpeg");
};
exports.getPlayerAvatar = getPlayerAvatar;
const getPlayerAvatarPath = (player) => {
    if (player.avatar) {
        // Nouveau format "s17/1.png"
        if (player.avatar.includes("/")) {
            const slashIdx = player.avatar.indexOf("/");
            const season = parseInt(player.avatar.slice(1, slashIdx), 10);
            return (0, avatarsSeason_1.getSeasonAvatarPath)(season);
        }
        const seasonAvatar = (0, avatarsSeason_1.findSeasonAvatar)(player.avatar);
        if (seasonAvatar) {
            return (0, avatarsSeason_1.getSeasonAvatarPath)(seasonAvatar.season);
        }
        return "tile/shop/avatar";
    }
    else if (player.avatarDefault) {
        return "tile/shop/avatar-default";
    }
    return null;
};
exports.getPlayerAvatarPath = getPlayerAvatarPath;
const getRaceFromCareer = (careerId) => {
    const career = getCareerFromKey(careerId);
    return career?.badge;
};
exports.getRaceFromCareer = getRaceFromCareer;
const getAvatarTypeFromPlayer = (player, avatarFile) => {
    const career = getCareerFromPlayer(player);
    if (avatarFile) {
        for (const avatarType of career.avatars) {
            const avatars = avatars_1.AVATAR_LIST[avatarType];
            if (avatars) {
                const findAvatar = avatars.find((al) => al.file === avatarFile);
                if (findAvatar) {
                    return avatarType;
                }
            }
            const avatarsDefault = avatarsDefault_1.AVATAR_DEFAULT_LIST[avatarType];
            if (avatarsDefault) {
                const findAvatarDefault = avatarsDefault.find((al) => al.file === avatarFile);
                if (findAvatarDefault) {
                    return avatarType;
                }
            }
        }
    }
    return null;
};
exports.getAvatarTypeFromPlayer = getAvatarTypeFromPlayer;
/** Returns the correct base path for an avatar file based on which list it belongs to,
 *  independent of the player's currently active avatar. */
const getAvatarBasePathFromFile = (player, avatarFile) => {
    const career = getCareerFromPlayer(player);
    if (!avatarFile)
        return null;
    for (const avatarType of career.avatars) {
        const avatars = avatars_1.AVATAR_LIST[avatarType];
        if (avatars?.find((al) => al.file === avatarFile)) {
            return "tile/shop/avatar";
        }
        const avatarsDefault = avatarsDefault_1.AVATAR_DEFAULT_LIST[avatarType];
        if (avatarsDefault?.find((al) => al.file === avatarFile)) {
            return "tile/shop/avatar-default";
        }
    }
    return null;
};
exports.getAvatarBasePathFromFile = getAvatarBasePathFromFile;
/** Returns the rarity string of a standard avatar file for the given player's career. */
const getAvatarRarityFromFile = (player, avatarFile) => {
    const career = getCareerFromPlayer(player);
    if (!avatarFile)
        return undefined;
    for (const avatarType of career.avatars) {
        const avatars = avatars_1.AVATAR_LIST[avatarType];
        const found = avatars?.find((al) => al.file === avatarFile);
        if (found)
            return found.rarity;
        const avatarsDefault = avatarsDefault_1.AVATAR_DEFAULT_LIST[avatarType];
        const foundDefault = avatarsDefault?.find((al) => al.file === avatarFile);
        if (foundDefault)
            return foundDefault.rarity;
    }
    return undefined;
};
exports.getAvatarRarityFromFile = getAvatarRarityFromFile;
const getRaceFromPlayer = (player) => {
    return getRaceFromCareer(getCareerKeyFromPlayer(player));
};
exports.getRaceFromPlayer = getRaceFromPlayer;
const getCareersByRace = () => {
    const carrers = {};
    for (const [name, values] of Object.entries((0, career_1.getCareers)())) {
        const badge = values.badge;
        if (!carrers[badge]) {
            carrers[badge] = [];
        }
        if (!carrers[badge][values.range]) {
            carrers[badge][values.range] = {};
        }
        carrers[badge][values.range][name] = values;
    }
    return carrers;
};
exports.getCareersByRace = getCareersByRace;
const getAvailableCareersByRace = () => {
    const carrers = {};
    for (const [name, values] of Object.entries((0, career_1.getAvailableCareers)())) {
        const badge = values.badge;
        if (!carrers[badge]) {
            carrers[badge] = [];
        }
        if (!carrers[badge][values.range]) {
            carrers[badge][values.range] = {};
        }
        carrers[badge][values.range][name] = values;
    }
    return carrers;
};
exports.getAvailableCareersByRace = getAvailableCareersByRace;
const GAIN_CAREER_POINT = 2;
exports.GAIN_CAREER_POINT = GAIN_CAREER_POINT;
const GAIN_CAREER_POINT_FRIENDLY = 2;
exports.GAIN_CAREER_POINT_FRIENDLY = GAIN_CAREER_POINT_FRIENDLY;
var GROUP_NAME;
(function (GROUP_NAME) {
    GROUP_NAME["AGILE"] = "group-agile";
    GROUP_NAME["CHAOTIC"] = "group-chaotic";
    GROUP_NAME["EXOTIC"] = "group-exotic";
    GROUP_NAME["NEUTRAL"] = "group-neutral";
    GROUP_NAME["VICIOUS"] = "group-vicious";
})(GROUP_NAME || (exports.GROUP_NAME = GROUP_NAME = {}));
const COMPATIBILITY = {
    [GROUP_NAME.AGILE]: [career_1.RACE.AMAZON, career_1.RACE.SILVAN, career_1.RACE.ELVEN_UNION, career_1.RACE.SLANN],
    [GROUP_NAME.CHAOTIC]: [
        career_1.RACE.ORC,
        career_1.RACE.CHAOS_DWARF,
        career_1.RACE.CHAOS,
        career_1.RACE.GOBELIN,
        career_1.RACE.KHORNE,
        career_1.RACE.NURGLE,
    ],
    [GROUP_NAME.EXOTIC]: [career_1.RACE.DWARF, career_1.RACE.NORSE, career_1.RACE.LIZARDMEN, career_1.RACE.UNDEAD],
    [GROUP_NAME.NEUTRAL]: [career_1.RACE.HALFLING, career_1.RACE.HUMAN, career_1.RACE.IMPERIAL],
    [GROUP_NAME.VICIOUS]: [
        career_1.RACE.DARK_ELFE,
        career_1.RACE.RAT,
        career_1.RACE.SNOTLING,
        career_1.RACE.NECROMANTIC,
        career_1.RACE.VAMPIRE,
    ],
};
exports.COMPATIBILITY = COMPATIBILITY;
const getPlayerGroup = (player) => {
    const race = getRaceFromPlayer(player);
    if (!race) {
        return undefined;
    }
    return getRaceGroup(race);
};
exports.getPlayerGroup = getPlayerGroup;
const getRaceGroup = (race) => {
    for (const group of Object.keys(COMPATIBILITY)) {
        if (COMPATIBILITY[group].includes(race)) {
            return group;
        }
    }
    return undefined;
};
exports.getRaceGroup = getRaceGroup;
const getRaceCompatibility = (race1, race2) => {
    const group1 = getRaceGroup(race1);
    const group2 = getRaceGroup(race2);
    if (group1 === group2 ||
        group1 === GROUP_NAME.NEUTRAL ||
        group2 === GROUP_NAME.NEUTRAL) {
        return true;
    }
    return false;
};
exports.getRaceCompatibility = getRaceCompatibility;
const getPlayerCompatibility = (player1, player2) => {
    const race1 = getRaceFromPlayer(player1);
    const race2 = getRaceFromPlayer(player2);
    if (!race1 || !race2) {
        return;
    }
    getRaceCompatibility(race1, race2);
};
exports.getPlayerCompatibility = getPlayerCompatibility;
const ranges = [16, 32, 48, 64, 80, 96];
function getCareerRanges() {
    return [0, ...ranges];
}
const NB_MAX_PLAYERS = 2;
function getPlayersAvailableForPromo(players = []) {
    const playersByState = getPlayersByState(players);
    return [...playersByState.actives, ...playersByState.lastRetired].slice(0, NB_MAX_PLAYERS);
}
function getPromoCareer(careerId, userPlayers) {
    const race = getRaceFromCareer(careerId);
    let promo = userPlayers
        .filter((p, i) => p && i < NB_MAX_PLAYERS && getRaceFromPlayer(p) === race)
        .reduce((p, c) => c.pc + p, 0);
    const price = getPriceCareer(careerId);
    if (promo > price / 2) {
        promo = price / 2;
    }
    return promo;
}
function getPriceCareer(careerId) {
    return getCareerRanges()[getCareerFromKey(careerId).range];
}
function getTeamGroups(team) {
    const groups = {};
    for (const player of team.players) {
        const group = getPlayerGroup(player);
        if (!group) {
            continue;
        }
        if (!groups[group]) {
            groups[group] = [];
        }
        groups[group].push(player);
    }
    return groups;
}
function isPlayerNeutralGroup(player) {
    const group = getPlayerGroup(player);
    const neutrals = [GROUP_NAME.NEUTRAL];
    return neutrals.includes(group);
}
function isNeutralGroup(group) {
    const neutrals = [GROUP_NAME.NEUTRAL];
    return neutrals.includes(group);
}
function getTeamIncompatibleGroups(team) {
    const groups = getTeamGroups(team);
    // return array of [name, players]: [['group-vicious', Array(8)], ...]
    return Object.entries(groups).filter((group) => !isNeutralGroup(group[0]));
}
const getPlayersByState = (players) => {
    const playerActives = [];
    const playerInactives = [];
    for (const p of players) {
        if ((0, state_1.canBeSelectedByUser)(p.state)) {
            playerActives.push(p);
        }
        else {
            playerInactives.push(p);
        }
    }
    return {
        actives: playerActives,
        inactives: playerInactives,
        // Check if works (.toString())
        lastRetired: playerInactives.sort((a, b) => Date.parse(b.connectedAt.toString()) -
            Date.parse(a.connectedAt.toString())),
    };
};
exports.getPlayersByState = getPlayersByState;
const getRaceSpecialSkills = (race) => {
    const careers = (0, career_1.getCareers)();
    const raceCareerIds = Object.keys(careers).filter((careerId) => careers[careerId].badge === race);
    if (raceCareerIds.length === 0) {
        return [];
    }
    // Compter la fréquence des compétences spéciales dans la race
    const skillCount = {};
    raceCareerIds.forEach((careerId) => {
        const careerSkills = careers[careerId].skills;
        careerSkills.forEach((skill) => {
            const skillName = Array.isArray(skill) ? skill[0] : skill;
            // Ne compter que les compétences spéciales
            if ((0, skill_1.isSpecialSkill)(skillName)) {
                skillCount[skillName] = (skillCount[skillName] || 0) + 1;
            }
        });
    });
    // Retourner les compétences spéciales qui apparaissent dans au moins 50% des carrières
    // Exclure les compétences de joueur individuel (specialist, big-guy) qui ne sont pas des compétences de race
    const threshold = Math.ceil(raceCareerIds.length * 0.5);
    const representativeSkills = Object.entries(skillCount)
        .filter(([_, count]) => count >= threshold)
        .map(([skillName, _]) => skillName)
        .filter((skillName) => skillName !== skill_1.SKILL_NAMES.SPECIALIST &&
        skillName !== skill_1.SKILL_NAMES.BIG_GUY);
    return representativeSkills;
};
exports.getRaceSpecialSkills = getRaceSpecialSkills;
